import { Link, useLocation } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();
  usePageMeta("页面未找到 - 91在线视频", "抱歉，您访问的页面不存在或已被移除，请返回首页浏览更多高清影视资源。");

  return (
    <div className="mx-auto flex w-full max-w-screen-2xl flex-col items-center justify-center px-4 py-28 text-center md:py-36">
      <span className="flex h-16 w-16 items-center justify-center rounded-lg bg-primary-500/15 text-accent-500">
        <i className="ri-film-line text-3xl" />
      </span>
      <p className="mt-6 font-heading text-6xl font-700 text-accent-500 md:text-7xl">404</p>
      <h1 className="mt-3 font-heading text-xl font-600 text-foreground-950 md:text-2xl">
        页面走丢了
      </h1>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        你访问的页面不存在或已被移除，换一条路继续观影吧。
      </p>
      <p className="mt-1 break-all text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-600 text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-5-line" />
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/60 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-500"
        >
          <i className="ri-compass-3-line" />
          浏览影视
        </Link>
      </div>
    </div>
  );
}